// extracted by mini-css-extract-plugin
module.exports = {"signupBlock":"signupBlock-9nU8G","signupBlockContainer":"signupBlockContainer-3PJAG","bglayer":"bglayer-8iHvn","signupBlockMobile":"signupBlockMobile-HLlMA"};